export { default } from './TablePagination';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/TablePagination/index.js
// module id = 817
// module chunks = 121